//#region Libraries
//#endregion
//#region Styles
import { Column } from "components/styles";
import { ContainerFooter, FooterTitle } from "../styles";
//#endregion
//#region Components
//#endregion
//#region Icons
import LocationIcon from "icons/LocationIcon";
import FieldInformation from "../FieldInformation/FieldInformation";
//#endregion

const PresentialFooter = ({
    data: {
        environment, campus,
        address, floor
    }
}) => {
    return (
        <Column>
            <FooterTitle>
                <span><LocationIcon size={15}/></span>
                <h3>¿Cómo llegar?</h3>  
            </FooterTitle>
            <ContainerFooter>
                <FieldInformation 
                    field="Ambiente:" 
                    value={environment}/>
                <FieldInformation 
                    field="Piso:" 
                    value={floor}/>
                <FieldInformation 
                    field={campus} 
                    value={address}
                    marginTop="20px"/>
            </ContainerFooter>
        </Column>
    );
}

export default PresentialFooter;